import Modal, { ModalProps } from "components/blocks/Modal";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {CourseOrderLocalItemResult} from "../../../../../services/courseOrder/models/CourseOrderType";
import {useQuery} from "../../../../../hooks/useQuery";
import {ExaminersService} from "../../../../../services/examinersService";
import {EXAMINER_TASK_STATUS} from "../tabs/OrderInfoTab/components/RefereesSection/ExaminersTable";
import {AccreditationType, ExaminerListResult} from "../../../../../services/examinersService/Model/ExaminerTypes";
import {RefereesService} from "../../../../../services/RefereeService";
import {RefereeListResult} from "../../../../../services/RefereeService/Model/RefereeTypes";
import FileUploadWithPreview from "../../../../../components/blocks/FileUploadWithPreview";

const GenericActionsModal: React.FC<
  ModalProps & {
    onSubmit: (notes: string,filesIds : string[]) => Promise<void>;
    isSubmitting: boolean;
    msg: string;
    type?:string;
    order? : CourseOrderLocalItemResult | null
    actionKey? :string;
  }
> = (props) => {
  const { isOpen, onClose, onSubmit, isSubmitting, msg,order,actionKey } = props;
  const { t } = useTranslation(["Orders"]);
  const [notes, setNotes] = useState("");
  const [filesIds, setFilesIds] = useState<string[]>([]);
  const [attachments, setAttachments]= useState<any>([]);

  const { data: selectedExaminers } = useQuery({
    queryFn: async () => {
      
      const data = await ExaminersService.getAllExaminersByOrderId(order?.id ??0);
      const sortedExaminers = data?.data.sort((a, b) => a.id - b.id);

      const uniqueExaminers = sortedExaminers?.reduce((acc, examiner) => {
        if (examiner.status === EXAMINER_TASK_STATUS.Submitted.value && examiner.accreditationType === "Accreditation" ) {
          acc[examiner.examinerName] = examiner;
        }

        return acc;
      }, {} as { [key: string]: ExaminerListResult });

      return {
        data: uniqueExaminers ? Object.values(uniqueExaminers) : [],
        code: data?.code,
        hasError: data?.hasError,
        description: data?.description,
      };
    },
    triggers: [isOpen, order?.id],
    options: {
      enabled: actionKey?.toLowerCase() ==="SendExaminer".toLowerCase() && isOpen,
    },
  });

   const { data: selectedReferees } = useQuery({
    queryFn: async () => {
      const data = await RefereesService.getAllRefereesByCourseOrderId(order?.id ??0);
      const sortedExaminers = data?.data.sort((a, b) => a.id - b.id);

      const uniqueExaminers = sortedExaminers?.reduce((acc, referee) => {
        if (referee.status === EXAMINER_TASK_STATUS.Submitted.value && referee.accreditationType === "Accreditation")  {
          acc[referee.refereeName] = referee;
        }

        return acc;
      }, {} as { [key: string]: RefereeListResult });

      return {
        data: uniqueExaminers ? Object.values(uniqueExaminers) : [],
        code: data?.code,
        hasError: data?.hasError,
        description: data?.description,
      };
    },
    triggers: [isOpen, order?.id],
    options: {
      enabled: actionKey?.toLowerCase() ==="SendReferee".toLowerCase() && isOpen,
    },
  });
  
  
  const onCancel = () => {
      setNotes("");
      setFilesIds([]);
      setAttachments([])
      onClose?.();
    
  };
  
  return (
    <Modal
      containerClassName="bg-white pb-2"
      isOpen={isOpen}
      onClose={onCancel}
      title={msg}
      withHeaderBorder
      size="lg"
      titleClassName="fs-6 text-dark"
      bodyMargin="py-3"
    >
      <FileUploadWithPreview
          label={t("uploadFile")}
          files={attachments}
          setFiles={setAttachments}
          onDelete={files => {
              setFilesIds(
                  files.map((x) => x.uuid)
              );
          }}
          isMultiple={true}
          onChange={(files) => {
            setFilesIds(
                files.map((x) => x.uuid)
            );
          }}
      />
      <label className="form-label mt-2">{t("Common:notes")}</label>
      <textarea
        className={`form-control`}
        rows={5}
        placeholder={t("Common:notes")}
        onChange={(e) => setNotes(e.target.value)}
        style={{ resize: "none" }}
      />

      {actionKey?.toLowerCase() ==="SendExaminer".toLowerCase() &&
          selectedExaminers?.length==0 &&
          ( <div className={"my-2"}>
            <span className={"text-danger fs-6 px-2"}>-</span>
            {t("you should Accreditation at least one evaluation first")}
          </div>)}   
      {actionKey?.toLowerCase() ==="SendReferee".toLowerCase() &&
          selectedReferees?.length==0 &&
          ( <div className={"my-2"}>
            <span className={"text-danger fs-6 px-2"}>-</span>
            {t("you should Accreditation at least one evaluation first")}  
       
          </div>)}
      
      
      <div className="divider mt-3"></div>

      <div className="d-flex justify-content-center gap-2 w-100">
        <button type="button" className="btn text-dark rounded-3 p-10-32P" onClick={onCancel}>
          {t("Common:cancel")}
        </button>
        
        <button
          type="button"
          className="btn btn-primary rounded-3 p-10-32P"
          disabled={(props?.type?.toLowerCase().includes("return") ||props?.type?.toLowerCase().includes("reject") ? (!notes.length || isSubmitting ): isSubmitting ) ||
              (selectedExaminers?.length==0 && actionKey?.toLowerCase() ==="SendExaminer".toLowerCase())||
              (selectedReferees?.length==0 && actionKey?.toLowerCase() ==="SendReferee".toLowerCase())
        }
          onClick={async () => {
            if (selectedExaminers?.length==0 && actionKey?.toLowerCase() ==="SendExaminer".toLowerCase() ||
                (selectedReferees?.length==0 && actionKey?.toLowerCase() ==="SendReferee".toLowerCase())) return;

            await onSubmit(notes,filesIds);
          }}
        >
          {!isSubmitting ? msg : <div className="custom-loader"></div>}
       
        </button>
      </div>
    </Modal>
  );
};
export default GenericActionsModal;
